import axios from "axios";

import { localStorageInstance } from "../utils/localStorage";
import { hideLoader, showLoader } from "../utils/loader";
import { subscriptionManager } from "../utils/subscriptionManager";
import { refreshToken } from "./apiAuth";
import {
  getAttemptedUrl,
  getRefreshTokenFromResponse,
  setTokenHeader,
} from "./axiosClientUtils";

export function createApiClient({ baseURL, getToken }) {
  const client = axios.create({
    baseURL: baseURL || "",
  });

  client.interceptors.request.use((request) => {
    setTokenHeader(request.headers, getToken());
    return request;
  });

  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error?.response?.status === 423) {
        subscriptionManager.notifyExpired();
        return Promise.reject(error);
      }

      if (error?.response?.status === 401) {
        showLoader();

        try {
          const refresh_token = localStorageInstance.getItem("refresh_token");

          if (!refresh_token) {
            throw new Error("No refresh token");
          }

          const response = await refreshToken(refresh_token);
          const token = getRefreshTokenFromResponse(response);

          localStorageInstance.setItem({
            key: "token",
            value: token?.access_token,
          });
          localStorageInstance.setItem({
            key: "refresh_token",
            value: token?.refresh_token,
          });

          setTokenHeader(
            error.config.headers,
            token?.access_token
          );

          hideLoader();
          return client.request(error.config);
        } catch (refreshError) {
          hideLoader();
          localStorageInstance.clear();
          const attemptedUrl = getAttemptedUrl(window.location);
          window.location = `${window.location.origin}?url=${attemptedUrl}`;
          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    }
  );

  return client;
}
